import { ddLLL, HHmm } from "@/helpers/dateHelper";
import { TimetableDepartureResponse } from "../api/TimetableDepartureResponse";

export class TimetableDeparture {
    departureDate: Date;
    date: string;
    start: string;
    end: string;
    price: number;
    locked: boolean;
    seatsLeft: number;

    constructor(resp: TimetableDepartureResponse) {
        this.departureDate = new Date(resp.departureDateTime);
        this.date = ddLLL(resp.arrivalDateTime);
        this.start = HHmm(resp.departureDateTime);
        this.end = HHmm(resp.arrivalDateTime);
        this.price = resp.price;
        this.locked = resp.locked;
        this.seatsLeft = resp.seatsLeft;
    }
}